"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _Links = require("@/common/model/Links");
var _util = require("@/utils/util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LinkModal',
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function data() {
    return {
      // 对话框标题
      title: '选择链接',
      // modal(对话框)是否可见
      visible: false,
      // loading状态
      isLoading: false,
      // 当前表单元素
      form: this.$form.createForm(this),
      // 所有链接数据
      linkList: _Links.linkList,
      // 当前选中的键值
      activeKey: '',
      // 当前选中的链接
      curItem: null,
      // 抽屉组件属性
      drawer: {
        visible: false,
        title: ''
      }
    };
  },
  computed: {
    keys: function keys() {
      var linkList = this.linkList;
      return linkList.map(function (item) {
        return item.key;
      });
    }
  },
  created: function created() {},
  methods: {
    // 显示对话框
    handle: function handle() {
      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.visible = true;
      if (record != null) {
        this.handleClickItem(record);
      }
    },
    // 选中事件
    handleClickItem: function handleClickItem(item) {
      // 取消选中值
      if (this.activeKey === item.id) {
        this.activeKey = '';
        this.curItem = null;
        return;
      }
      // 记录选中值
      this.activeKey = item.id;
      this.curItem = _lodash.default.cloneDeep(item);
      // 显示表单
      this.onShowFrom();
    },
    // 显示表单
    onShowFrom: function onShowFrom() {
      var curItem = this.curItem;
      if (curItem.form && curItem.form.length) {
        // 显示抽屉
        this.onShowDrawer();
      }
    },
    // 显示抽屉
    onShowDrawer: function onShowDrawer() {
      var drawer = this.drawer,
        curItem = this.curItem;
      drawer.visible = true;
      drawer.title = curItem.title;
    },
    // 关闭抽屉
    onCloseDrawer: function onCloseDrawer() {
      this.activeKey = '';
      this.curItem = null;
      this.drawer.visible = false;
    },
    // 关闭对话框事件
    handleCancel: function handleCancel() {
      this.visible = false;
      this.onCloseDrawer();
    },
    // 确认按钮
    handleSubmit: function handleSubmit(e) {
      var _this = this;
      e.preventDefault();
      var curItem = this.curItem,
        validateFields = this.form.validateFields;
      validateFields(function (errors, formData) {
        if (!errors) {
          // 创建返回结果
          var result = curItem ? _this.buildResult(curItem, formData) : null;
          // 通知父端组件提交完成了
          _this.$emit('handleSubmit', result);
          // 关闭对话框
          _this.handleCancel();
        }
      });
    },
    // 构建选中的link对象
    buildResult: function buildResult(link, formData) {
      for (var index in link.form) {
        var item = link.form[index];
        if (!item) {
          continue;
        }
        // 记录输入的数据
        if (!formData.values[index]) {
          formData.values[index] = '';
        }
        // 将value赋值到key指向的param对象元素
        item.value = formData.values[index];
        _lodash.default.set(link.param, item.key, item.value);
      }
      // 将link对象拼接为url
      if (link.type === 'PAGE') {
        link.param.url = (0, _util.buildUrL)(link.param.path, link.param.query);
      }
      // 克隆一个新对象返回
      return _lodash.default.cloneDeep(link);
    }
  }
};